import { render, staticRenderFns } from "./UserCreateFormStep2.vue?vue&type=template&id=aed0d4d6&scoped=true"
import script from "./UserCreateFormStep2.vue?vue&type=script&lang=js"
export * from "./UserCreateFormStep2.vue?vue&type=script&lang=js"
import style0 from "./UserCreateFormStep2.vue?vue&type=style&index=0&id=aed0d4d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed0d4d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aed0d4d6')) {
      api.createRecord('aed0d4d6', component.options)
    } else {
      api.reload('aed0d4d6', component.options)
    }
    module.hot.accept("./UserCreateFormStep2.vue?vue&type=template&id=aed0d4d6&scoped=true", function () {
      api.rerender('aed0d4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/CreateForm/UserCreateFormStep2.vue"
export default component.exports